module.exports = "/_next/static/images/more-a7d052dff7ceb5f73091a6039e147fb4.svg";